export const Constants = {
  preview: 'preview',
};

export const MonorailPageIndicators = {
  profileIndex: 'Profile index',
  profileListing: 'Profile show',
  serviceIndex: 'Service index',
  categoryIndex: 'Category index',
  expertIndex: 'Expert index',
  home: 'Home',
  createAJob: 'Create a job',
  requestAQuote: 'Request a quote',
  login: 'Login',
};

export const GoogleAnalyticsKey = 'UA-82702-49';

export const GoogleAnalyticsEventActions = {
  navigationClick: 'Navigation click',
  createAJob: 'Create a job',
  requestQuote: 'Request a quote',
  login: 'Login',
  serviceCardClick: 'Service card click',
};

export const GoogleAnalyticsEventCategories = {
  user: 'User',
};

export enum GoogleAnalyticsEventType {
  Event = 'event',
  PageView = 'pageview',
}
